export enum PremiumCode {
    Mtpl = 'Visos EPAP',
}
